
import React,{ useEffect, useState,useRef } from 'react';
import {  ReceiveQuestionsMultiDomain, ReceiveScore, SubmitAnswer } from '../../services/KnowledgeTest';
import Webcam from "react-webcam";
import micImg from '../../Assets/circle.png';
import muteImg from '../../Assets/mute.png';
import { SendVideo } from '../../services/PyschometricTest';
import Header from '../../components/Navigation/Header';
import flagged from '../../Assets/flagged.png';
import sendAudioToOpenAIWhisper from '../../utils/transcribeAudio';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import clock from '../../Assets/clock.png';
import { useContext } from 'react';
import { userDetails } from '../../context/User';

function KnowledgeTestSwipe(){
  
    const [questions,setQuestion]=useState([]);
    const [options,setOptions]=useState([]);
    const [questionID,setQuestionID]=useState('');
    const [questionCategories,setQuestionCategory]=useState('');
    const [tags,setTags]=useState('');
    const [originalAnswer,setOriginalAnswer]=useState([]);

    const [candidateAnswer,setcandidateAnswer]=useState();

    const [score,setScore]=useState(0);

    const [index,setIndex]=useState(0)


    const [flagging,setFlagged]=useState((Array.from({length:5},(_,index)=>index+1)));
    
    const [userAnswer,setUserAnswer]=useState('');


    const navigate=useNavigate();
    const [editTranscribe,setEditTranscibe] = useState('');

    const [completedQuestions,setCompletedQuestions]=useState(0);

    const [updateTrigger, setUpdateTrigger] = useState(0);

  const [currentQuestionIndex,setCurrentQuestionIndex]=useState();
const [totalQuestions, setTotalQuestions] = useState(0);

      const {user}=useContext(userDetails);
  
    // const completedQuestionCheck=async()=>{
    //   {const questions=await ReceiveQuestions();
      
    //   let completedQuestions= questions?.data.length;
    //   let totalQuestions=questions?.total;
    //   const newCount = totalQuestions - completedQuestions;
    //   setCurrentQuestionIndex(newCount);
    //   setCompletedQuestions(prev => (prev !== newCount ? newCount : prev));
    //   setUpdateTrigger(prev => prev + 1);
    //   }
    // }
  
  //  useEffect(()=>{completedQuestionCheck()},[updateTrigger]);


      const fetchQuestion=async()=>{

        
              if (!user?.profile?.registeredPosition?.role || !user?.profile?.registeredPosition?.primaryDomain) {

                  console.log('Profile data not loaded yet');
                  return;
              }

              const domains=[];

              if (user?.profile?.registeredPosition?.primaryDomain) {
                domains.push(user.profile.registeredPosition.primaryDomain);
              }

              // Add preferred domains if they exist and are an array
              if (Array.isArray(user?.profile?.preferredDomains) && user.profile.preferredDomains.length > 0) {
                user.profile.preferredDomains.forEach(domain => domains.push(domain));
              }

            console.log('domains',user);  

            const roleName = user.profile?.registeredPosition?.role;

              if (!roleName) {
                  console.error('Role name not found');
                  return;
              }

            const experience= user.profile?.registeredPosition.experienceLevel
            if (!experience) {
                  console.error('Experience not found');
                  return;
              }


        const questions=await ReceiveQuestionsMultiDomain(roleName,domains,experience);
                console.log('knowledge questions',experience,roleName,domains,questions);

        setIndex(0);
        // console.log('question',questions,index);
        const question=[]
        const originalAnswer=[]
        const categories=[]
        const tags=[]
        const questionsIDs=[]
        const options=[]
        if(questions && questions.success)
        {
        questions?.data.forEach(e => {
        question.push(e.question);
        questionsIDs.push(e.id);
        categories.push('knowledge');
        options.push(e.options.map(opt => opt.option_text)); 
        originalAnswer.push(e.answer);
        tags.push(e.area);
      });
        setOptions(options);
        setQuestionID(questionsIDs)
        setQuestionCategory(categories)
        setTags(tags)
        setOriginalAnswer(originalAnswer);
        setQuestion(question);
        setTotalQuestions(questions?.total); 
        setCurrentQuestionIndex(questions?.total - questions?.data.length);  
        setCompletedQuestions(questions?.total - questions?.data.length);   
        // setTotalQuestions(questions?.total);
        setFlagged(Array.from({length:questions?.total},(_,index)=>index+1));

        if (questions?.data.length === 0 || questions?.completed) {
          navigate('score');
          return;
        }

        return;
        }
   }

    useEffect(()=>{fetchQuestion()},[]);
  
  const initialTime = 3 * 60; // 3 minutes in seconds
  const storedTime = localStorage.getItem("timerKnowledge");

  const calculateTimeLeft = () => {
    if (storedTime) {
      const now = Math.floor(Date.now() / 1000); // Get current time in seconds
      const timeLeft = storedTime - now;
      return timeLeft > 0 ? timeLeft : 0;
    }
    return initialTime;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  
  const resetTimer = () => {
    const endTime = Math.floor(Date.now() / 1000) + initialTime;
    localStorage.setItem("timerKnowledge", endTime);
    setTimeLeft(initialTime);
  };

  useEffect(() => {
    if (timeLeft <= 0) {
      SubmitQuestionHandler();
      return;
    };
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          localStorage.removeItem("timerKnowledge");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  // Save end time in localStorage when timer starts
  useEffect(() => {
    if (!storedTime) {
      const endTime = Math.floor(Date.now() / 1000) + initialTime;
      localStorage.setItem("timerKnowledge", endTime);
    }
  }, []);

  // Convert seconds to MM:SS format
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

    async function HandlingScores(candidateAnswer)
    {
      // console.log('que',questions);
      const dataReceived=await ReceiveScore({question:questionID[index],candidateAnswer:candidateAnswer});
      // console.log('score',dataReceived.score);
      if(dataReceived.success)
      {
        // console.log(dataReceived,"candidatae",candidateAnswer);
        setScore(dataReceived.score);
        return dataReceived.score;
      }
      // console.log("Issue in receiving scores");
    }  
    useEffect(()=>setcandidateAnswer(""),[index]);

const handleAnswerSubmit = async (e) => {
  resetTimer();
  
  // Simple check: is this the last question in our current questions array?
  const isLastQuestion = index >= questions.length - 1;
  
  console.log('Index:', index, 'Questions length:', questions.length, 'Is Last:', isLastQuestion);
  
  const updatedScore = await HandlingScores(userAnswer);
  await SubmitAnswer({
    questionID: questionID[index],
    originalAnswer: originalAnswer[index],
    answer: userAnswer || "not given",
    score: updatedScore,
    userID: Cookies.get('id'),
    category: questionCategories[index],
    completed: isLastQuestion, 
    tag: tags[index],
    totalQuestions: totalQuestions 
  });
}
    
   const SubmitQuestionHandler=(e)=>{

    handleAnswerSubmit(e);
    setIndex(prev=>prev+1);
    setEditTranscibe('')
    setOptionChange(''); 
    setUserAnswer('');
   }
   const navigateToScore=()=>{
    if(index>=questions?.length-1)
      {
        navigate('score')
        return;
      }
    }

   const [optionChange,setOptionChange]=useState('');

   const changeOption=(id,answer)=>{
    setOptionChange(id);
    // console.log('answer',answer);
    setUserAnswer(answer);
   }

   useEffect(() => {
    setOptionChange(null); 
  }, [index]);

  return(
    <>
        <Header />
        
        <main className='pyschometrictestcontainer'>
            {/* Header Section with Timer */}
            <section className='pyschometrictext'>
                <div className='topfield'>
                    <div className='topsubfield'>
                        <h1>Knowledge Test</h1>
                        <nav className='breadcrumb' aria-label='Breadcrumb'>
                            <span>Home</span>
                            <span aria-hidden="true"> &nbsp; &gt;&nbsp;  </span>
                            <span>Knowledge Test</span>
                            <span aria-hidden="true"> &nbsp;  &gt; &nbsp; </span>
                            <span style={{color:'#8A090D'}}>Quiz</span>
                        </nav>
                    </div>
                    
                    <div className='timer' role='timer' aria-live='polite' aria-atomic='true'>
                        <div>
                            <img src={clock} alt='Timer icon' />
                            <h2>{formatTime(timeLeft)}</h2>
                        </div>
                    </div>
                </div>
            </section>

            {/* Main Content Section */}
            <section className='swipecontainer'>
                {/* Question Container */}
                <article className='questionswipesubcontainer' style={{width:"70%"}}>
                    <header className='questionpointer'>
                       <h2>Question No: {currentQuestionIndex !== undefined ? currentQuestionIndex + 1 : index + 1}</h2>

                        <p>{questions[index]}</p>
                    </header>
                    
                    {/* Options List */}
                    <div className='options-list' role='radiogroup' aria-labelledby='question-header'>
                        {options[index]?.map((option, idx) => (
                            <label 
                                key={idx}
                                className={`checkbox ${optionChange === idx ? "selected" : ""}`}
                                htmlFor={`option-${index}-${idx}`}
                            >
                                <input 
                                    type='radio' 
                                    id={`option-${index}-${idx}`} 
                                    name={`question-${index}`} 
                                    value={option}
                                    checked={optionChange === idx} 
                                    onChange={() => changeOption(idx, option)}
                                    aria-checked={optionChange === idx}
                                />
                                <span className='option-text'>{option}</span>
                            </label>
                        ))}
                    </div>
                </article>

                {/* Question Navigation Sidebar */}
                <aside className='flaggedquestions' aria-label='Question navigation' style={{marginLeft:"20px"}}>
                    <div>
                        <h3>Questions</h3>
                        <nav className='flagged' aria-label='Question status'>
                         {
                        flagging.map((element, index) => {
                          const totalCount = flagging.length;
                          // Size decreases as count increases
                          const size = Math.max(30, 50 - (totalCount - 10) * 1.0); // Min 30px
                          const fontSize = Math.max(12, 20 - (totalCount - 10) * 0.6); // Min 12px
                          
                          return (
                            <button 
                              key={index} 
                              className={index < completedQuestions ? "answered" : "notanswered"}
                              style={{
                                width: `${size}px`,
                                height: `${size}px`,
                                fontSize: `${fontSize}px`
                              }}
                            >
                              {element}
                            </button>
                          );
                        })
                      }
                        </nav>
                    </div>
                </aside>
            </section>
        </main>

        {/* Footer with Navigation */}
        <footer className='bottombar'>
            <div className='proceedbtns'>
                <button 
                    type='button'
                    onClick={(e) => {
                        SubmitQuestionHandler(e);
                        navigateToScore();
                    }}
                    aria-label={index === questions?.length - 1 ? 'Submit test' : 'Go to next question'}
                >
                   {(currentQuestionIndex + index + 1) >= totalQuestions ? 'Submit' : 'Next'}

                </button>
            </div>
        </footer>
    </>
);
}

export default KnowledgeTestSwipe;